<template>
  <NuxtLayout name="markup" background-class="bg-surface-tertiary">
    <MarkupGenerator :page-data="data" :is-page="true" />
  </NuxtLayout>
</template>

<script setup lang="ts">
import { general_setPageTheme } from '~/utils/general/pageThemeClassFromMarkup';
import { ASYNC_KEY_PREPAID_LISTING } from '~/models/AsyncDataKeys.model';

const config = useRuntimeConfig();
const route = useRoute();
const { $api } = useNuxtApp();
const notifications = useNotificationStore();
notifications.reset();

definePageMeta({
  layout: false,
});

const { data, error } = await useAsyncData(
  ASYNC_KEY_PREPAID_LISTING,
  async () => {
    return await $api.categoryModule.getCategory(3);
  },
  {
    transform: cache_addFetchedAtTransform,
    getCachedData: cache_getCachedDataFromServer,
  },
);

const hasError = error.value || !data.value?.PageContent;

if (hasError) {
  notifications.setStandardErrorNotification();
}

general_setPageTheme(data.value?.PageContent);

const canonicalUrl = `${config.public.apiBaseUrl.replace(/\/$/, '')}${route.fullPath.split('?')[0]}`;

const seoInput = {
  seoData: {
    title: '',
    description: '',
    siteName: '',
    keywords: '',
    canonicalUrl,
  },
  fallBackSeoData: {
    title: 'Kontantkort | Halebop.se',
    description:
      'Fixa Halebop idag, då får du fria SMS till hela världen och massor med surf.  Vi har de senaste Mobiltelefonerna från Apple, Samsung, Nokia, Sony och många fler',
    siteName: 'Halebop',
    keywords: '',
    canonicalUrl,
  },
};
useCustomSeoMeta(seoInput);
</script>
<style scoped lang="scss"></style>
